export default __webpack_public_path__ + "static/283-cd775428b860f0a190b14b5d71b92d13.gif";